// Tiny markdown renderer. Handles paragraphs, unordered lists, inline code,
// **bold**, [text](url) links. NO heavy library; the cockpit only needs this
// for the note-editor preview.

function escape(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(s: string): string {
  let out = escape(s);
  // Inline code first so the bold/link regexes don't eat backtick contents.
  out = out.replace(/`([^`]+)`/g, "<code>$1</code>");
  out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  out = out.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    (_m, label: string, href: string) => {
      const safe = href.replace(/"/g, "%22");
      return `<a href="${safe}" target="_blank" rel="noopener noreferrer">${label}</a>`;
    },
  );
  return out;
}

export function renderMarkdown(src: string): string {
  if (!src) return "";
  const lines = src.replace(/\r\n/g, "\n").split("\n");
  const out: string[] = [];
  let buf: string[] = [];
  let listBuf: string[] = [];

  const flushPara = () => {
    if (!buf.length) return;
    out.push(`<p>${inline(buf.join(" "))}</p>`);
    buf = [];
  };
  const flushList = () => {
    if (!listBuf.length) return;
    out.push(`<ul>${listBuf.map((l) => `<li>${inline(l)}</li>`).join("")}</ul>`);
    listBuf = [];
  };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      flushPara();
      flushList();
      continue;
    }
    const liMatch = /^[-*]\s+(.*)$/.exec(line);
    if (liMatch) {
      flushPara();
      listBuf.push(liMatch[1]);
      continue;
    }
    flushList();
    buf.push(line);
  }
  flushPara();
  flushList();
  return out.join("");
}
